import { Injectable } from '@angular/core';

const CLASSNAME = 'LocalService';

@Injectable()
export class LocalService {
    public set(key: string, value: any) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (err) {
            console.error(CLASSNAME, 'set', err);
        }
    }

    public get<T>(key: string): T {
        let result: T;
        try {
            result = JSON.parse(localStorage.getItem(key));
        } catch (err) {
            console.error(CLASSNAME, 'get', err);
        }
        return result;
    }

    public remove(key: string) {
        localStorage.removeItem(key);
    }
}
